export default __webpack_public_path__ + "static/media/benefit4.6ccb2427.svg";